import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import axios from 'axios'
import { auth } from '../services/api/auth'

import * as getters from './getters'

import { TokenStorage } from "../services/token"

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app
  },
  state: {
    user: null,
    isAuthorized:false
  },
  mutations: {
    logout_request(){
      TokenStorage.clear();
    },
    auth_error() {
      //TODO:
    },
    auth_request() {
      //TODO:
    },
    auth_success(state, { user }) {
      state.user = user;
      state.isAuthorized = true;
    }
  },
  accessToken: null,
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        auth.login(user.email, user.password)
          .then(user => {
            commit("auth_success", { user });
            resolve(user);
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({commit}){
      return new Promise((resolve, reject) => {
        commit('logout_request')
        resolve();
      });
    }
  }
})

Vue.use(VuexI18n.plugin, store)

export default store
